var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common" },
    [
      _c(
        "search-form",
        {
          attrs: { formConfig: _vm.formConfig, source: _vm.searchData },
          on: { search: _vm.search }
        },
        [
          +_vm.msgStCd === 0
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c("button-load", {
                    staticClass: "search-btn-item btn-blue-line",
                    attrs: {
                      lable: "设为已读",
                      disabled: _vm.selectedRows.length == 0
                    },
                    on: { clickHandle: _vm.readList }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-common" },
        [
          _c("a-table", {
            attrs: {
              size: "middle",
              columns: _vm.columns,
              "row-key": function(record) {
                return record.id
              },
              "data-source": _vm.tableData,
              pagination: _vm.pagination,
              loading: _vm.loading,
              bordered: "",
              scroll: _vm.columns.length > 10 ? { x: "100%" } : {},
              locale: { emptyText: "暂无数据" },
              "row-selection": _vm.tableSelect
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "msgCntnt",
                fn: function(text) {
                  return [
                    _c("div", { staticClass: "ellipsis" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getText(text)) +
                          "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "createTime",
                fn: function(text) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd HH:MM"))
                    )
                  ]
                }
              },
              {
                key: "operation",
                fn: function(text, record) {
                  return [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.toPageDetail(record)
                          }
                        }
                      },
                      [_vm._v("详情")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("transferPdfView", { ref: "transferPdfView" }),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "通知详情",
            width: "80%",
            footer: null,
            destroyOnClose: ""
          },
          on: {
            cancel: function($event) {
              _vm.notificationModal = false
            }
          },
          model: {
            value: _vm.notificationModal,
            callback: function($$v) {
              _vm.notificationModal = $$v
            },
            expression: "notificationModal"
          }
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleFormImport",
              attrs: {
                model: _vm.notificationFormData,
                "label-col": { span: 8 },
                "wrapper-col": { span: 13 }
              }
            },
            [
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "8px" },
                  attrs: { label: "标题", prop: "importType" }
                },
                [
                  _c("a-input", {
                    attrs: { readonly: "", placeholder: "请输入" },
                    model: {
                      value: _vm.notificationFormData.msgTtl,
                      callback: function($$v) {
                        _vm.$set(_vm.notificationFormData, "msgTtl", $$v)
                      },
                      expression: "notificationFormData.msgTtl"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "8px" },
                  attrs: { label: "内容", prop: "msgCntnt" }
                },
                [
                  _c("a-textarea", {
                    attrs: { placeholder: "", rows: 4, readonly: "" },
                    model: {
                      value: _vm.notificationFormData.msgCntnt,
                      callback: function($$v) {
                        _vm.$set(_vm.notificationFormData, "msgCntnt", $$v)
                      },
                      expression: "notificationFormData.msgCntnt"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05f872ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f872ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/message/transferNotice/list.vue
// module id = jHZs
// module chunks = 1